import { getApiFromModule } from './GetContentsByModule';

export const includeDescendantCategoryIds = (selectedIds: number[], tree: any[]): number[] => {
    const ids = new Set(selectedIds.map(Number));
    const visit = (nodes: any[], selectedParent = false) => {
        nodes.forEach(node => {
            const id = Number(node.category_id);
            const selected = selectedParent || ids.has(id);
            if (selected && Number.isFinite(id)) ids.add(id);
            visit(node.children ?? [], selected);
        });
    };
    visit(tree);
    return [...ids];
};

/** Resolve a named category branch without assuming a fixed category ID. */
export const getCategoryBranchIds = (slug: string, tree: any[]): number[] => {
    const roots: number[] = [];
    const visit = (nodes: any[]) => nodes.forEach(node => {
        if ((node.page_slug ?? node.slug) === slug) roots.push(Number(node.category_id));
        visit(node.children ?? []);
    });
    visit(tree);
    return includeDescendantCategoryIds(roots, tree);
};

export const getCategoryFilter = async (selectedIds: number[], context: any) => {
    if (!selectedIds.length) return {};
    const data = await getApiFromModule('categories', context).getVisitTree(null, {
        workspace_id: context?.workspace?.workspace_id,
    });
    const tree = data?.results ?? data?.data ?? data ?? [];
    return { 'categories.category.category_id_in': JSON.stringify(includeDescendantCategoryIds(selectedIds, tree)) };
};
